module.exports = __webpack_public_path__ + "static/media/Goias_SVG.e6dc5564.svg";